// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"default-src_app_shared_components_warning-modal_warning-modal_component_ts-node_modules_angul-e08d22":"67465aa38dbefb3d","src_app_modules_classes_classes_module_ts":"f0813889ac491ede","src_app_modules_admin_admin_module_ts":"d24cbc186814e2fb"}[chunkId] + ".js";
};